/** 前端授權判定：以目前公司 membership 的 org_role 為準，不以舊 JWT 角色當跨公司管理員。 */
export const ORG_ROLE_LABEL = {
  org_admin: '公司管理員',
  team_manager: '團隊主管',
  member: '成員',
};

export function isOrgAdmin(org) {
  if (!org) return false;
  if (org.org_role) return org.org_role === 'org_admin';
  // 示範資料或舊 localStorage 只有顯示文字
  return org.role === '管理員';
}

export function orgRoleLabel(org) {
  if (!org) return ORG_ROLE_LABEL.member;
  if (org.org_role && ORG_ROLE_LABEL[org.org_role]) return ORG_ROLE_LABEL[org.org_role];
  return org.role || ORG_ROLE_LABEL.member;
}

/** CEO 用語：賣房／賣車；鍵仍為 real_estate / automotive */
export const MODULE_LABEL = {
  real_estate: '賣房（房仲）',
  automotive: '賣車（汽車業）',
};

export const MODULE_KEYS = ['real_estate', 'automotive'];

export const MODULE_HINT = {
  real_estate: '開通稅試算、調謄本、搜房',
  automotive: '開通車輛紀錄、名片王、號牌查詢',
};

/** 舊 localStorage 沒有 modules 時視為全開（與後端回填一致），避免既有公司突然看不到功能 */
export function hasModule(org, key) {
  if (!org) return false;
  const mods = org.modules;
  if (!Array.isArray(mods)) return true;
  return mods.includes(key);
}

export function hasAnyModule(org, keys) {
  if (!org || !Array.isArray(keys) || !keys.length) return false;
  return keys.some((k) => hasModule(org, k));
}

/** 商機：有賣房或賣車任一即可；目錄再依模組過濾 */
export function canAccessOpportunities(org) {
  return hasAnyModule(org, MODULE_KEYS);
}

/**
 * 路由閘道輔助：回傳拒絕原因字串，通過則回 null。
 * @param {object|null} org
 * @param {{ module?: string, anyOf?: string[] }} opts
 */
export function moduleRouteDenied(org, { module, anyOf } = {}) {
  if (!org) return '請先選擇要進入的公司，才能使用此功能。';
  if (module) {
    if (hasModule(org, module)) return null;
    const label = MODULE_LABEL[module] || module;
    return `目前公司尚未開通「${label}」，無法使用此功能。若需要開通，請聯繫平台管理員。`;
  }
  if (anyOf && anyOf.length) {
    if (hasAnyModule(org, anyOf)) return null;
    const labels = anyOf.map((k) => MODULE_LABEL[k] || k).join('或');
    return `目前公司尚未開通「${labels}」，無法使用此功能。若需要開通，請聯繫平台管理員。`;
  }
  return null;
}
